import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function generatePassword(): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%'
  return Array.from({ length: 12 }, () =>
    chars[Math.floor(Math.random() * chars.length)]
  ).join('')
}

// Prices are stored in EUR; only the presentation follows the viewer's language.
export function formatCurrency(amount: number, locale: string): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
  }).format(amount)
}

export function formatDate(date: Date, locale: string): string {
  return date.toLocaleDateString(locale, { dateStyle: 'medium' })
}

export function formatDateTime(date: Date, locale: string): string {
  return date.toLocaleString(locale, { dateStyle: 'medium', timeStyle: 'short' })
}
